import { twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: "/api/auth",
  plugins: [twoFactorClient()],
});

/** Better Auth error codes → messages shown to users. */
export function authErrorMessage(err: { code?: string; message?: string; status?: number } | null | undefined): string {
  switch (err?.code) {
    case "INVALID_EMAIL_OR_PASSWORD":
      return "メールアドレスまたはパスワードが正しくありません";
    case "INVALID_TWO_FACTOR_AUTHENTICATION":
    case "INVALID_CODE":
    case "INVALID_TOTP":
      return "確認コードが正しくありません。認証アプリの最新のコードを入力してください";
    case "INVALID_PASSWORD":
      return "パスワードが正しくありません";
    case "PASSWORD_TOO_SHORT":
      return "パスワードは12文字以上にしてください";
    case "INVALID_TOKEN":
      return "リンクの有効期限が切れています。もう一度お手続きください";
    case "INVALID_BACKUP_CODE":
      return "バックアップコードが正しくありません。保存したコードを1つ、そのまま入力してください（各コードは1回だけ使えます）";
    case "INVALID_TWO_FACTOR_COOKIE":
      return "確認の時間が切れました。お手数ですが、ログインからやり直してください";
    case "TOO_MANY_ATTEMPTS_REQUEST_NEW_CODE":
    case "ACCOUNT_TEMPORARILY_LOCKED":
      return "確認の失敗が続いたため、一時的にログインを止めています。しばらく待ってから、ログインからやり直してください";
    case "BACKUP_CODES_NOT_ENABLED":
    case "TWO_FACTOR_NOT_ENABLED":
      return "このアカウントでは二段階認証が設定されていません。ログインからやり直してください";
  }
  if (err?.status === 429) return "試行回数が多すぎます。しばらく待ってから再度お試しください";
  return err?.message ? `エラーが発生しました（${err.message}）` : "エラーが発生しました";
}
